import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    control: {
      button: 'lg:group c-white p-2 pr-0 flex center',
      circle: 'fill-brand-1/50',
      circleInactive: 'group-hover:fill-brand-1/90',
      icon: 'transform duration group-hover:scale-112',
      wrapper: 'bottom-0 m-2 <lg:mr-4'
    }
  },
  controlsSize: 'sm'
} satisfies VfConfig['video']
